import axios from 'axios';

// Base URL should be just the host, not include /api
// In production (when VITE_API_URL is empty), use current origin (handled by nginx proxy)
// In development, use localhost:4001
const API_BASE_URL = import.meta.env.VITE_API_URL ||
  (import.meta.env.MODE === 'production' ? window.location.origin : 'http://localhost:4001');

// Create a separate axios instance for auth requests (without interceptors)
const authAxios = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Important for HttpOnly cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Auth API - Authentication endpoints
 */
const authApi = {
  /**
   * Login with email and password
   */
  login: async (email, password) => {
    const response = await authAxios.post('/api/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  /**
   * Logout (revoke refresh token)
   */
  logout: async (accessToken) => {
    const response = await authAxios.post(
      '/api/auth/logout',
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  },

  /**
   * Refresh access token using refresh token in HttpOnly cookie
   */
  refreshAccessToken: async () => {
    const response = await authAxios.post('/api/auth/refresh', {}, { timeout: 15000 });
    return response.data;
  },

  /**
   * Get current user data
   */
  getCurrentUser: async (accessToken) => {
    const response = await authAxios.get('/api/auth/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },

  getInvitation: async (token) => {
    const response = await authAxios.get(`/api/auth/invitations/${token}`);
    return response.data;
  },

  acceptInvitation: async (token, password) => {
    const response = await authAxios.post(`/api/auth/invitations/${token}/accept`, { password });
    return response.data;
  },
};

export default authApi;
